import { render, staticRenderFns } from "./EligibilityCover.vue?vue&type=template&id=4847bdb6&scoped=true&"
import script from "./EligibilityCover.vue?vue&type=script&lang=js&"
export * from "./EligibilityCover.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityCover.vue?vue&type=style&index=0&id=4847bdb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4847bdb6",
  null
  
)

export default component.exports